import { useTranslation } from "react-i18next";
import { PageTitleBar } from './layout/PageBar';
import { ReactNode } from "react";

function ConfirmEmail(): ReactNode {
    const { t } = useTranslation(['confirm_email', 'base']);

    return (
        <>
            {/* Заголовок переехал во второй этаж шапки — в теле он дублировался бы. */}
            <PageTitleBar title={t('string_1')} />
            <div className="max-width text-page-padding">
                <p>{t('string_2')}</p>
            </div>
        </>
    )
}

export default ConfirmEmail;